import './FallbackCountries.scss';
import React from 'react';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';

type FallbackCountriesProps = {
    isGlobalFallback: boolean;
    fallbackCountries: string[];
};

const FallbackCountries = ({
    isGlobalFallback,
    fallbackCountries
}: FallbackCountriesProps) => {
    const { t } = useTranslation();

    const countries = fallbackCountries.map(country => country.split('/')[2]);

    const names = countries.join(', ');

    if (isEmpty(fallbackCountries) && !isGlobalFallback) {
        return (
            <span className="b-fallback-countries">
                {t('playlist_no_fallback')}
            </span>
        );
    }
    return (
        <span className="b-fallback-countries" data-testid='fallback-countries'>{`${
            isGlobalFallback ? 'Global' : names}`}</span>
    );
};

export default FallbackCountries;
